import { getSettingChatAnswerBotName } from "@faire/help-center-utils/settings/getSettingChatAnswerBotName";
import { getSettingChatFaireBotName } from "@faire/help-center-utils/settings/getSettingChatFaireBotName";
export var FAIRE_BOT_ROLE = "business";
export var FAIRE_BOT_NAME = getSettingChatFaireBotName();
export var ANSWER_BOT_NAME = getSettingChatAnswerBotName();
// This is the key used to store the chat metadata in local storage
export var FAIRE_CHAT_METADATA = "faireChatMetadata";
export var FAIRE_CHAT_CSAT_FEEDBACK_SUBMITTED_STORAGE_KEY = "faireChatCsatFeedbackSubmitted";
export var INIT_SEND_FAIRE_BOT_PROMPT_MESSAGE = "Connecting...";
export var MessagePayload;
(function (MessagePayload) {
  MessagePayload["END_TEXT_MESSAGE"] = "end_text_message";
  MessagePayload["TRANSFER_MESSAGE"] = "transfer_message";
  MessagePayload["OFFLINE_MESSAGE"] = "offline_message";
  MessagePayload["NPS_GOOD"] = "nps_good";
  MessagePayload["NPS_BAD"] = "nps_bad";
  MessagePayload["BAD_CSAT_FEEDBACK_MESSAGE"] = "bad_csat_feedback_message";
  MessagePayload["CSAT_MESSAGE"] = "csat_message";
  MessagePayload["INIT_SEND_FAIRE_BOT_PROMPT"] = "init_send_faire_bot_prompt";
  MessagePayload["INIT_MESSAGE"] = "initial_message";
})(MessagePayload || (MessagePayload = {}));